import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { emailValidator } from 'src/app/_utlis/app-validators';
import { BuyerService } from '../../_services/buyer/buyer.service';
import { BuyerAuthService } from '../buyer-authentication/services/buyer-auth/buyer-auth.service';
import { Router, RouterOutlet, RouterLink } from '@angular/router';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';


import { MatCard, MatCardContent } from '@angular/material/card';
import { LogoComponent } from '../../../../Shared/components/logo/logo.component';
import {
  MatFormField,
  MatError,
  MatSuffix,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { isPlatformBrowser } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorStateService } from 'src/app/Shared/_services/error-state/error-state.service';
import { InlineErrorStatusComponent } from 'src/app/Shared/components/inline-error-status/inline-error-status.component';

@Component({
    selector: 'app-buyer-layout',
        standalone: true,
templateUrl: './buyer-layout.component.html',
    styleUrls: ['./buyer-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
    RouterOutlet,
    ReactiveFormsModule,
    InlineErrorStatusComponent
]
})
export class BuyerLayoutComponent implements OnInit, OnDestroy {
  showLogin!: boolean;
  loginClicked!: boolean;
  formData!: FormGroup;
  loginSub$!: Subscription;
  showLoginSub$!: Subscription;
  buyerDefualtPath = environment.wordpressUrl;

  isBrowser: boolean;
  isLoggedIn = false;

  // Error state signal for inline error display
  errorState = this.errorStateService.error;

  constructor(
    private fb: FormBuilder,
    private buyerService: BuyerService,
    private toastService: ToastService,
    private auth: BuyerAuthService,
    private authService: BuyerAuthService,
    private router: Router,
    private storage: StorageService,
    @Inject(PLATFORM_ID) private platformId: any,
    private errorStateService: ErrorStateService
  ) {
    this.initForm();
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  ngOnInit(): void {
    this.showLoginSub$ = this.buyerService.showLogin$.subscribe((res) => {
      if (!res) {
        this.formData.reset();
        if (this.isBrowser) {
          document.body.style.overflow = '';
        }
      } else {
        if (this.isBrowser) {
          document.body.style.overflow = 'hidden';
        }
      }
      this.showLogin = res;
    });

    this.loginSub$ = this.auth.loggedIn_authorized$.subscribe((res) => {
      this.isLoggedIn = res;
    });
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.loginSub$) {
      this.loginSub$.unsubscribe();
    }
    if (this.showLoginSub$) {
      this.showLoginSub$.unsubscribe();
    }
  }
  initForm() {
    this.formData = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([Validators.required, emailValidator])
      ),
      password: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  onSubmit() {
    this.toastService.clear();

    if (this.formData.valid) {
      this.loginClicked = true;
      // this.isLoading = true;
      this.authService.login(this.formData.value).subscribe({
        next: (response: { data: { token: string; user: any } }) => {
          const { user, token } = response.data;

          if (!user.email_verified_at) {
            this.router.navigate(['/buyer/auth/verify-email'], {
              queryParams: { email: user.email },
            });
          } else {
            this.storage.userToken = token;
            this.storage.userData = JSON.stringify(user);
            this.authService.setLoggedIn_authorized(true);
            this.loginClicked = false;

            this.closePopUp();
          }
        },
        error: (error) => {
          this.loginClicked = false;

          this.toastService.showError(error?.error?.Error[0]);
        },
      });
    }
  }
  closePopUp() {
    this.loginClicked = false;
    if (this.isBrowser) {
      document.body.style.overflow = 'auto';
    }

    this.buyerService.setShowLogin(false);
  }
}
